/* eslint-disable */
import React from 'react'

export default ({children}) => (
	<div className="results">
		{children}
	</div>
)


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/reportWrapper.js